document.addEventListener("DOMContentLoaded", function () {
  // Read Liquid-generated data from the JSON island
  const data = JSON.parse(document.getElementById('kopstorm-data')?.textContent || '{}');
  const inv_qty = data.inv_qty || {};
  const variantSize = data.variantSize || {};

  function decodeHTMLEntities(text) {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = text;
    return textArea.value;
  }

  document.addEventListener("variant:change", function (event) {
    const variant = event.detail.variant;
    const guide = document.getElementById("product_sizeguide");
    const sizeInfo = variantSize[variant.id];

    if (guide) {
      guide.innerText = sizeInfo && sizeInfo.trim() ? decodeHTMLEntities(sizeInfo) : "";
    }
  });

  // Country list toggle
  const countryList = document.getElementById("CountryList");
  document.getElementById("selectmarket")?.addEventListener("click", () => {
    countryList?.classList.toggle("display-block");
    countryList?.classList.toggle("display-none");
  });

  document.querySelectorAll(".dicsl").forEach(el => {
    el.addEventListener("click", () => {
      countryList?.classList.remove("display-block");
      countryList?.classList.add("display-none");
    });
  });

  // Market switch button
  const marketSwitch = document.getElementById("marketswitch");
  document.querySelectorAll("#countrylink").forEach(link => {
    link.addEventListener("click", function () {
      const value = this.getAttribute("data-value");
      marketSwitch?.setAttribute("data-value", value);
      marketSwitch.style.opacity = 1;
      marketSwitch.style.pointerEvents = "auto";
      countryList.style.display = "none";
    });
  });

  if (marketSwitch && !marketSwitch.getAttribute("data-value")) {
    marketSwitch.style.opacity = 0.75;
    marketSwitch.style.pointerEvents = "none";
  }

  // Language selector close
  document.getElementById("language_selector2")?.addEventListener("click", () => {
    const menu = document.getElementById("header-sidebar-menu");
    if (menu) {
      menu.style.opacity = "0";
      menu.style.visibility = "hidden";
      document.documentElement.style.overflow = "auto";
    }
  });

  // Fade effects (throttled with rAF)
  const fadeEls = [".fade_1", ".fade_2", ".fade_3"].map(s => document.querySelector(s)).filter(Boolean);
  if (fadeEls.length) {
    let fadeTicking = false;
    window.addEventListener("scroll", () => {
      if (!fadeTicking) {
        fadeTicking = true;
        requestAnimationFrame(() => {
          fadeEls.forEach(el => { el.style.opacity = el.offsetHeight >= 25 ? 0 : 1; });
          fadeTicking = false;
        });
      }
    }, { passive: true });
  }

  // Language & country triggers
  const triggerToggles = {
    ".trigger_button_1": "CountryList",
    ".trigger_button_2": "LanguageList",
  };

  Object.entries(triggerToggles).forEach(([btnClass, listId]) => {
    document.querySelector(btnClass)?.addEventListener("click", () => {
      const list = document.getElementById(listId);
      if (list) {
        list.style.display = list.style.display === "block" ? "none" : "block";
      }
    });
  });

  // Modal open / close for mp1 & mp2
  document.getElementById("mp2_open_mp1")?.addEventListener("click", () => {
    document.getElementById("mp1")?.classList.add("visible");
    document.getElementById("mp2")?.classList.remove("visible");
  });

  document.getElementById("mp1_open_mp2")?.addEventListener("click", () => {
    document.getElementById("mp2")?.classList.add("visible");
    document.getElementById("mp1")?.classList.remove("visible");
  });

  document.getElementById("language_selector")?.addEventListener("click", () => {
    document.getElementById("mp2")?.classList.add("visible");
  });

  document.getElementById("language_selector-footer")?.addEventListener("click", () => {
    document.getElementById("mp2")?.classList.add("visible");
  });

  document.addEventListener("click", function (event) {
    const mp1 = document.getElementById("mp1");
    const mp2 = document.getElementById("mp2");

    if (
      mp1?.classList.contains("visible") &&
      !event.target.closest("#mp1") &&
      !event.target.closest("#mp2_open_mp1")
    ) {
      mp1.classList.remove("visible");
    }

    if (
      mp2?.classList.contains("visible") &&
      !event.target.closest("#mp2") &&
      !event.target.closest("#mp1_open_mp2") &&
      !event.target.closest("#language_selector") &&
      !event.target.closest("#language_selector-footer")
    ) {
      mp2.classList.remove("visible");
    }
  });

  // Dropdown animation
  document.querySelectorAll(".trigger_button_2").forEach(button => {
    button.addEventListener("click", () => {
      button.querySelector(".animated-icon")?.classList.toggle("rotate");
    });
  });

  // Selected country flag & name in header
  document.querySelectorAll("#CountryList .disclosure__item").forEach(item => {
    item.addEventListener("click", () => {
      const text = item.querySelector("p")?.textContent;
      const img = item.querySelector("img")?.src;
      const selectMarket = document.getElementById("selectmarket");

      if (selectMarket && text && img) {
        selectMarket.innerHTML = "";
        const wrapper = document.createElement("div");
        wrapper.classList.add("flexbox-class");

        const info = document.createElement("div");
        const flag = document.createElement("img");
        flag.src = img;
        flag.alt = "Selected Flag";
        flag.classList.add("countryflagpopup");

        const countryText = document.createElement("p");
        countryText.textContent = text;

        info.appendChild(flag);
        info.appendChild(countryText);
        wrapper.appendChild(info);

        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("style", "width: 12px;");
        svg.setAttribute("class", "icon icon-caret animated-icon");
        svg.setAttribute("viewBox", "0 0 10 6");

        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttribute("fill-rule", "evenodd");
        path.setAttribute("clip-rule", "evenodd");
        path.setAttribute("d", "M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z");
        path.setAttribute("fill", "currentColor");

        svg.appendChild(path);
        wrapper.appendChild(svg);
        selectMarket.appendChild(wrapper);
      }
    });
  });

  // Product card color selector
  document.querySelectorAll(".product-card").forEach(card => {
    const colorTrigger = card.querySelector(".color-trigger");
    const checked = card.querySelector("input[type='radio']:checked");
    if (checked) {
      const label = card.querySelector(`label[for="${checked.id}"]`);
      colorTrigger.textContent = label?.getAttribute("color") || "";
    }

    card.querySelectorAll(".product-card__swatch-list label").forEach(label => {
      label.addEventListener("click", () => {
        const colorValue = label.getAttribute("color");
        colorTrigger.textContent = colorValue;
      });
    });
  });

});
